import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCogwheel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#cogwheel-clip)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m2.364 10.239.88 1.522-.543 2.417 2.598 1.5L7.121 14H8.88l1.822 1.678 2.598-1.5-.542-2.417.879-1.522L16 9.5v-3l-2.364-.739-.88-1.522.543-2.417-2.598-1.5L8.879 2H7.12L5.3.322l-2.598 1.5.542 2.417-.879 1.522L0 6.5v3zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "cogwheel-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgCogwheel;
